<template>

  <HeaderSection />

  <section id="formulario" class="bg-gray-100 py-12" >

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-gray-700">

      <div class="container mx-auto px-4 max-w-5xl">

        <h1 class="font-bold text-gray-800 mb-0 text-2xl text-center pt-5">
          ACREDITARME
        </h1>
        <h1 class="text-gray-800 mb-4 text-2xl text-center pt-2 pb-5">
          Por favor complete el formulario en su totalidad
        </h1>
        
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Nombre</label>
            <Field name="nombre" v-slot="{ field, errors }" v-model="formData.nombre">
              <InputText v-bind="field" type="text"  placeholder="Nombre"  class="w-full p-inputtext-sm p-3 text-sm rounded-lg border" :class="{ 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="nombre" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Apellido</label>
            <Field name="apellido" v-slot="{ field, errors }" v-model="formData.apellido">
              <InputText v-bind="field" type="text"  placeholder="Apellido"  class="w-full p-inputtext-sm p-3 text-sm rounded-lg border" :class="{ 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="apellido" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/1">
            <label class="block mb-1">DNI / Pasaporte</label>
            <Field name="documento" v-slot="{ field, errors }" v-model="formData.documento">
              <InputText v-bind="field" type="numeric"  placeholder="Documento / Pasaporte"  class="w-full p-inputtext-sm p-3 text-sm rounded-lg border" :class="{ 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="documento" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Empresa</label>
            <Field name="empresa" v-slot="{ field, errors }" v-model="formData.empresa">
              <InputText v-bind="field" type="text"  placeholder="Empresa"  class="w-full p-inputtext-sm p-3 text-sm rounded-lg border" :class="{ 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="empresa" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Cargo</label>
            <Field name="cargo" v-slot="{ field, errors }" v-model="formData.cargo">
              <InputText v-bind="field" type="text"  placeholder="Cargo"  class="w-full p-inputtext-sm p-3 text-sm rounded-lg border" :class="{ 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="cargo" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-8/12">
            <label class="block mb-1">Dirección</label>
            <Field name="direccion" v-slot="{ field, errors }" v-model="formData.direccion">
              <InputText v-bind="field" type="text"  placeholder="Dirección"  class="w-full p-inputtext-sm p-3 text-sm rounded-lg border" :class="{ 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="direccion" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">Código postal</label>
            <Field name="codigoPostal" v-slot="{ field, errors }" v-model="formData.codigoPostal">
              <InputText v-bind="field" type="text"  placeholder="Cargo"  class="w-full p-inputtext-sm p-3 text-sm rounded-lg border" :class="{ 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="codigoPostal" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Localidad</label>
            <Field name="localidad" v-slot="{ field, errors }" v-model="formData.localidad">
              <InputText v-bind="field" type="text"  placeholder="Localidad"  class="w-full p-inputtext-sm p-3 text-sm rounded-lg border" :class="{ 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="localidad" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Provincia</label>
            <Field name="provincia" v-slot="{ field, errors }" v-model="formData.provincia">
              <InputText v-bind="field" type="text"  placeholder="Cargo"  class="w-full p-inputtext-sm p-3 text-sm rounded-lg border" :class="{ 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="provincia" /></span>
            </Field>
          </div>
        </div>

        <!-- Telefono fijo -->
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-4/12">
              <label class="block mb-1">País</label>
              <Dropdown v-model="selectedCountryFijo" :options="paises" optionLabel="descripcion" placeholder="Seleccione un país" class="w-full md:w-14rem p-inputtext-sm"/>
          </div>
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">Código de país</label>
            <InputText type="text" v-if="selectedCountryFijo !== null" v-model="selectedCountryFijo.id" class="w-full p-inputtext-sm p-3" readonly />
          </div>
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">Código de área</label>
            <Field name="codigoAreaFijo" v-slot="{ field, errors }" v-model="formData.codigoAreaFijo">
              <InputText v-bind="field" type="text"  class="w-full p-inputtext-sm p-3 text-sm rounded-lg border" :class="{ 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="codigoAreaFijo" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">Teléfono fijo</label>
            <Field name="telefonoFijo" v-slot="{ field, errors }" v-model="formData.telefonoFijo">
              <InputText v-bind="field" type="text"  class="w-full p-inputtext-sm p-3 text-sm rounded-lg border" :class="{ 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="telefonoFijo" /></span>
            </Field>
          </div>
        </div>

        <!-- Telefono fijo -->
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-4/12">
              <label class="block mb-1">País</label>
              <Dropdown v-model="selectedCountryCel" :options="paises" optionLabel="descripcion" placeholder="Seleccione un país" class="w-full md:w-14rem p-inputtext-sm"/>
          </div>
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">Código de país</label>
            <InputText type="text" v-if="selectedCountryCel !== null" v-model="selectedCountryCel.id" class="w-full p-inputtext-sm p-3" readonly />
          </div>
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">Código de área</label>
            <Field name="codigoAreaCel" v-slot="{ field, errors }" v-model="formData.codigoAreaCel">
              <InputText v-bind="field" type="text"  class="w-full p-inputtext-sm p-3 text-sm rounded-lg border" :class="{ 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="codigoAreaCel" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">Teléfono celular</label>
            <Field name="telefonoCelular" v-slot="{ field, errors }" v-model="formData.telefonoCelular">
              <InputText v-bind="field" type="text"  class="w-full p-inputtext-sm p-3 text-sm rounded-lg border" :class="{ 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="telefonoCelular" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Mail</label>
            <Field name="mail" v-slot="{ field, errors }" v-model="formData.mail">
              <InputText v-bind="field" type="text"  placeholder="Mail"  class="w-full p-inputtext-sm p-3 text-sm rounded-lg border" :class="{ 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="mail" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Web Site</label>
            <Field name="webSite" v-slot="{ field, errors }" v-model="formData.webSite">
              <InputText v-bind="field" type="text"  placeholder="Web site"  class="w-full p-inputtext-sm p-3 text-sm rounded-lg border" :class="{ 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="webSite" /></span>
            </Field>
          </div>
        </div>

        <!-- Combos -->
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/4">
            <label class="block mb-1">Prefesión / Actividad</label>
            <Field name="profesion" v-slot="{ handleChange, handleBlur, value , errors}" v-model="formData.profesion">
                <Dropdown @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione su profesión" class="w-full p-inputtext-sm" :options="profesiones" optionLabel="descripcion" :class="{ 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && value !== undefined, 'bg-red-50 border border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}" />
                <span class="text-sm text-red-500 p-error"><ErrorMessage name="profesion" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/4">
            <label class="block mb-1">Otra profesión</label>
            <Field name="profesionOtra" v-slot="{ field, errors }" v-model="formData.profesionOtra">
              <InputText v-bind="field" :readonly="formData.profesion?.id !== 'Otro'" type="text"  placeholder="Otra profesión"  class="w-full p-inputtext-sm p-3 text-sm rounded-lg border" :class="{ 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="profesionOtra" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/4">
            <label class="block mb-1">Rubro de su empresa</label>
            <Field name="rubro" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.rubro">
                <Dropdown @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione el rubro" class="w-full p-inputtext-sm" :options="rubros" optionLabel="descripcion" :class="{ 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0  && value !== undefined, 'bg-red-50 border border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}"  />
                <span class="text-sm text-red-500 p-error"><ErrorMessage name="rubro" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/4">
            <label class="block mb-1">Otro rubro</label>
            <Field name="rubroOtro" v-slot="{ field, errors }" v-model="formData.rubroOtro">
              <InputText v-bind="field" :readonly="formData.rubro?.id !== 'Otro'" type="text"  placeholder="Otro rubro"  class="w-full p-inputtext-sm p-3 text-sm rounded-lg border" :class="{ 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="rubroOtro" /></span>
            </Field>
          </div>
        </div>
        
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/4">
            <label class="block mb-1">¿Cómo se enteró?</label>
            <Field name="medio" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.medio">
                <Dropdown @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione el medio" class="w-full p-inputtext-sm" :options="medios" optionLabel="descripcion" :class="{ 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0  && value !== undefined, 'bg-red-50 border border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}" />
                <span class="text-sm text-red-500 p-error"><ErrorMessage name="medio" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/4">
            <label class="block mb-1">Otro medio</label>
            <Field name="medioOtro" v-slot="{ field, errors }" v-model="formData.medioOtro">
              <InputText v-bind="field" :readonly="formData.medio?.id !== 'Otro'" type="text"  placeholder="Otro medio"  class="w-full p-inputtext-sm p-3 text-sm rounded-lg border" :class="{ 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="medioOtro" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Rol en la compra</label>
            <Field name="rolCompra" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.rolCompra">
                <Dropdown @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione su rol" class="w-full p-inputtext-sm" :options="rolesCompra" optionLabel="descripcion" :class="{ 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && value !== undefined, 'bg-red-50 border border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}" />
                <span class="text-sm text-red-500 p-error"><ErrorMessage name="rolCompra" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Seleccione su rango etario</label>
            <Field name="rangoEtario" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.rangoEtario">
                <Dropdown @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione su rango etario" class="w-full p-inputtext-sm" :options="rangosEtarios" optionLabel="descripcion" :class="{ 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && value !== undefined, 'bg-red-50 border border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}" />
                <span class="text-sm text-red-500 p-error"><ErrorMessage name="rangoEtario" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Seleccione el objetivo de su visita</label>
            <Field name="objetivo" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.objetivo">
                <Dropdown @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione el objetivo de su visita" class="w-full p-inputtext-sm" :options="objetivos" optionLabel="descripcion" :class="{ 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && value !== undefined, 'bg-red-50 border border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}" />
                <span class="text-sm text-red-500 p-error"><ErrorMessage name="objetivo" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2">
            <label class="block mb-1">Seleccione sus rubros de interés</label>
            <Field name="rubrosInteres" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.rubrosInteres">
              <MultiSelect @blur="handleBlur" @update:model-value="handleChange" :model-value="value" :options="rubrosInteresList" optionLabel="descripcion" placeholder="Seleccione los canales de interés" :showToggleAll="false" class="w-full p-inputtext-sm text-sm rounded-lg border" :class="{ 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && value !== undefined, 'bg-red-50 border border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="rubrosInteres" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap py-2 mt-3">
          <button type="submit" label="REGISTRARME" class="mt-4 px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded" :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i>REGISTRARME
          </button>
        </div>

      </div>

      <BlockUI :blocked="isSubmitting" fullScreen />

    </Form>

  </section>

</template>

<script lang="ts">
import * as yup from 'yup';

import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import InputText from 'primevue/inputtext';
import Dropdown from 'primevue/dropdown';
import MultiSelect from 'primevue/multiselect';
import BlockUI from 'primevue/blockui';
import HeaderSection from './HeaderSection.vue';

import jsonCountries from '@/data/countries.json';
import jsonMedios from '@/data/medios.json';
import jsonObjetivos from '@/data/objetivos.json';
import jsonProfesiones from '@/data/profesiones.json';
import jsonRolesCompra from '@/data/rolesCompra.json';
import jsonRubros from '@/data/rubros.json';
import jsonRubrosInteres from '@/data/rubrosInteres.json';
import jsonRagosEtarios from '@/data/rangosEtarios.json';

import suiteService, { Acreditado, TipoAcreditado, EstadoAcreditado, StringIdLabelEntity, OrigenAcreditado } from 'qreventos-suite/services';
import suiteConfig from '@/services/suite.config';
import { SAVE, ORIGEN_ACREDITADO, VERIFICADO } from "qreventos-suite/constantes";

interface Pais  extends StringIdLabelEntity {}
interface Medio extends StringIdLabelEntity {}
interface Objetivo extends StringIdLabelEntity {}
interface Profesion extends StringIdLabelEntity {}
interface Rubro extends StringIdLabelEntity {}
interface RolCompra extends StringIdLabelEntity {}
interface RubroInteres extends StringIdLabelEntity {}
interface RangoEtario extends StringIdLabelEntity {}

export default defineComponent({
  components: {
    HeaderSection,
    InputText, Dropdown, MultiSelect,
    Field, ErrorMessage, Form, BlockUI
  },
  created () {
    document.title = "BATEV 2024 - Acreditación";
    suiteConfig.evento = 227;
  },
  data() {
    return {
      paises: [] as Pais[],
      profesiones: [] as Profesion[],
      rubros: [] as Rubro[],
      medios: [] as Medio[],
      rolesCompra : [] as RolCompra[],
      objetivos: [] as Objetivo[],
      rubrosInteresList: [] as RubroInteres[],
      rangosEtarios: [] as RangoEtario[],
      selectedCountryCel: {"id": "+54", "descripcion": "Argentina"} as Pais,
      selectedCountryFijo: {"id": "+54", "descripcion": "Argentina"} as Pais,
      isSubmitting: false,
      formData: {
        nombre: '',
        apellido: '',
        documento: '',
        empresa: '',
        cargo: '',
        direccion: '',
        codigoPostal: '',
        localidad: '',
        provincia: '',
        codigoAreaCel: '',
        codigoAreaFijo: '',
        telefonoCelular: '',
        telefonoFijo: '',
        mail:  '',
        webSite: '',
        profesion: undefined as unknown as Profesion,
        profesionOtra: '',
        rubro: undefined as unknown as Rubro,
        rubroOtro: '',
        medio: undefined as unknown as Medio,
        medioOtro: '',
        rolCompra: undefined as unknown as RolCompra,
        objetivo: undefined as unknown as Objetivo,
        rubrosInteres: undefined as unknown as RubroInteres[],
        rangoEtario: undefined as unknown as RangoEtario
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        nombre: yup.string().required('Ingrese su nombre').min(3, 'Al menos 3 letras'),
        apellido: yup.string().required('Ingrese su apellido').min(3, 'Al menos 3 letras'),
        documento: yup.string().required('Ingrese su documento').min(6, 'Al menos 6 números'),
        empresa: yup.string().required('Ingrese su empresa').min(3, 'Al menos 3 letras'),
        cargo: yup.string().required('Ingrese su cargo').min(3, 'Al menos 3 letras'),
        direccion: yup.string().required('Ingrese la dirección').min(3, 'Al menos 3 letras'),
        codigoPostal: yup.string().required('Ingrese el código postal').min(3, 'Al menos 3 letras'),
        localidad: yup.string().required('Ingrese la localidad').min(3, 'Al menos 3 letras'),
        provincia: yup.string().required('Ingrese la provincia').min(3, 'Al menos 3 letras'),
        codigoAreaFijo: yup.string().required('Código de área').matches(/^\d+$/, 'Solo se permiten números'),
        telefonoFijo: yup.string().required('Ingrese el teléfono fijo').matches(/^\d+$/, 'Solo se permiten números'),
        codigoAreaCel: yup.string().required('Código de área').matches(/^\d+$/, 'Solo se permiten números'),
        telefonoCelular: yup.string().required('Ingrese el celular').matches(/^\d+$/, 'Solo se permiten números'),
        mail: yup.string().required('Ingrese su correo').email('Correo inválido'),
        webSite: yup.string().required('Ingrese su web'),
        
        profesion: yup.mixed().required('Seleccione su profesión'),
        profesionOtra: yup.string().test('validacion-profesion', 'Especifique cual', function(value) {
          const profesionSelected = this.parent.profesion;
          if(profesionSelected?.id === 'Otro' && !value) {
              return false;
          }
          return true;
        }),

        rubro: yup.mixed().required('Seleccione el rubro'),
        rubroOtro: yup.string().test('validacion-rubro', 'Especifique cual', function(value) {
          const rubroSelected = this.parent.rubro;
          if(rubroSelected?.id === 'Otro' && !value) {
              return false;
          }
          return true;
        }),

        medio: yup.mixed().required('Seleccione el medio'),
        medioOtro: yup.string().test('validacion-medio', 'Especifique cual', function(value) {
          const medioSelected = this.parent.medio;
          if(medioSelected?.id === 'Otro' && !value) {
              return false;
          }
          return true;
        }),
        
        rolCompra : yup.mixed().required('Seleccione su rol en la compra'),
        objetivo : yup.mixed().required('Seleccione el objetivo de su visita'),
        rubrosInteres : yup.mixed().required('Seleccione sus rubros de interés'),
        rangoEtario : yup.mixed().required('Seleccione su rango etario'),

      });
    }
  },
  watch: {
    'formData.profesion.id'(newValue) {
      if (newValue !== 'Otro') {
        this.formData.profesionOtra = '';
      }
    },
    'formData.rubro.id'(newValue) {
      if (newValue !== 'Otro') {
        this.formData.rubroOtro = '';
      }
    },
    'formData.medio.id'(newValue) {
      if (newValue !== 'Otro') {
        this.formData.medioOtro = '';
      }
    },
  },
  methods: {
    async onSubmit() {
      this.isSubmitting = true;

      let acreditadoExistente:Acreditado = await suiteService.findAcreditadoByFilters(suiteConfig.evento, "dni="+this.formData.documento) as Acreditado;
      if (acreditadoExistente) {
        Swal.fire({ 
            title: "Atención", 
            html: "El DNI / Pasaporte ingresado ya fue registrado.<br/><br/>Le enviamos un mail para informarle el estado de su registración. <br/><br/>Por favor revise su casilla de correo y de spam.",
            icon: "warning" }).then(() => {
              window.location.href = "https://www.batev.com.ar";
        });
        return;
      }

      let acreditado:Acreditado = new Object() as Acreditado;
      acreditado.tipoAcreditado = { "id": 493 } as TipoAcreditado;
      acreditado.estadoAcreditado = { "id": VERIFICADO } as EstadoAcreditado;
      acreditado.nombre = this.formData.nombre;
      acreditado.apellido = this.formData.apellido;
      acreditado.dni = this.formData.documento;
      acreditado.empresa = this.formData.empresa;
      acreditado.cargo = this.formData.cargo;
      acreditado.mail = this.formData.mail;
      
      acreditado.telefono = this.selectedCountryCel.id + this.formData.codigoAreaCel + this.formData.telefonoCelular;
      acreditado.origenAcreditado = { "id" : ORIGEN_ACREDITADO } as OrigenAcreditado;
      acreditado.modificado = SAVE;
      acreditado.cantidad = 1;
      acreditado.notificar = true;
      acreditado.notificarWhatsApp = false;
      
      acreditado.datos = {} as any;
      acreditado.datos["2425"] = this.formData.direccion;
      acreditado.datos["2423"] = this.formData.codigoPostal;
      acreditado.datos["2424"] = this.formData.localidad;
      acreditado.datos["2420"] = this.formData.provincia;
      acreditado.datos["2435"] = this.selectedCountryCel?.descripcion;
      acreditado.datos["2431"] = this.selectedCountryFijo?.id;
      acreditado.datos["2432"] = this.formData.codigoAreaFijo;
      acreditado.datos["2421"] = this.formData.telefonoFijo;
      acreditado.datos["2422"] = this.formData.webSite;
      acreditado.datos["2426"] = this.formData.profesion?.id != 'Otro'? this.formData.profesion?.id : this.formData.profesionOtra;
      acreditado.datos["2428"] = this.formData.rubro?.id != 'Otro'? this.formData.rubro?.id : this.formData.rubroOtro;
      acreditado.datos["2430"] = this.formData.medio?.id != 'Otro'? this.formData.medio?.id : this.formData.medioOtro;
      acreditado.datos["2427"] = this.formData.rolCompra?.id;
      acreditado.datos["2429"] = this.formData.objetivo?.id;
      acreditado.datos["2436"] = this.formData.rubrosInteres.map(rubro => rubro.descripcion).join(', ');
      acreditado.datos["4199"] = this.formData.rangoEtario?.id;

      try {
        await suiteService.saveOrUpdate(suiteConfig.evento, acreditado);
        
        Swal.fire({
            title: "Acreditación exitosa",
            html: "Estimado/a:<br>Hemos recibido sus datos de registración con éxito.<br/><br/>Le enviamos un mail con un enlace para descargar su credencial para concurrir al evento.<br/><br/>Por favor revise su casilla de correo y de spam.",
            icon: "success",
        }).then(() => {
          window.location.href = "https://www.batev.com.ar";
        });

      } catch(error) {
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    }
  },
  async mounted() {
    this.paises = jsonCountries;
    this.profesiones = jsonProfesiones;
    this.rubros = jsonRubros;
    this.medios = jsonMedios;
    this.rolesCompra = jsonRolesCompra;
    this.objetivos = jsonObjetivos;
    this.rubrosInteresList = jsonRubrosInteres;
    this.rangosEtarios = jsonRagosEtarios;
  }
});
</script>
